'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _themeCurrency = require('@shopify/theme-currency');

var _handlebarsMin = require('handlebars/dist/handlebars.min.js');

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

var _limelight = require('@dotdev/limelight');

var _limelight2 = _interopRequireDefault(_limelight);

var _shopifyCart = require('shopify-cart');

var _shopifyCart2 = _interopRequireDefault(_shopifyCart);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _handlebarsHelpers = require('../modules/handlebars-helpers');

var _handlebarsHelpers2 = _interopRequireDefault(_handlebarsHelpers);

var _slickCarousel = require('slick-carousel');

var _slickCarousel2 = _interopRequireDefault(_slickCarousel);

var _slick = require('../modules/slick');

var _slick2 = _interopRequireDefault(_slick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.npmjs.com/package/shopify-cart/v/1.0.7
(0, _handlebarsHelpers2.default)();

_shopifyCart2.default.prototype.addToCart = function onClickAddToCartButton(event) {
  var idInput = document.querySelector('[name=id]');
  var quantityInput = document.querySelector('[name=quantity]');
  var propertyInputs = document.querySelectorAll('[name*=properties]');
  var id = Number(idInput.value || idInput.options[idInput.selectedIndex].value);
  var quantity = Number(quantityInput.value);
  // const note = document.querySelector('[name="cart-note"]').value;
  var properties = {};

  // Create an object of properties from the properties input fields
  for (var input = 0; input < propertyInputs.length; input += 1) {
    var element = propertyInputs[input];
    if (element.type === 'radio' && !element.checked) {
      continue;
    }
    var key = element.getAttribute('name').split('[')[1].split(']')[0];
    var value = element.value;
    properties[key] = value;
  }
  var data = {
    id: id,
    quantity: quantity,
    properties: properties
  };
  var $recharge = (0, _jquery2.default)('input[type="radio"][value="subsave"]:checked');
  var $sellingPlans = (0, _jquery2.default)('[data-plans-dropdown]');
  if ($recharge.length) {
    data[$recharge.attr('name')] = (0, _jquery2.default)('input[type="radio"][value="subsave"]:checked').val();
    data[$sellingPlans.attr('name')] = $sellingPlans.val();
  }
  this.addItem(data);
};

var cartRendering = function cartRendering() {
  // Build an ajax cart
  window.AjaxCart = new _shopifyCart2.default({
    cart: window.theme.cart,
    options: {
      getUrl: '/cart?view=json',
      timeOut: 500
    },
    selectors: {
      addItemText: '[data-add-to-cart-text]'
    }
  });

  // Cart popup selectors
  var PopupCart = new _limelight2.default('#PopupCart', {
    bodyClass: 'active-popup'
  });
  var miniCartTemplate = document.querySelector('#MiniCartTemplate');
  var popupCartContainer = document.querySelector('#PopupCartContainer');
  var hoverCartContainer = document.querySelector('#HoverCartContainer');
  var cartQty = document.querySelectorAll('#CartQty');
  var cartActive = document.querySelectorAll('[data-cart-active]');
  var hoverCartStickyContainer = document.querySelector('#HoverCartStickyContainer');

  // Cart added selectors
  var PopupAdded = new _limelight2.default('#PopupAdded', {
    bodyClass: 'active-popup',
    beforeShowCallback: function beforeShowCallback(element, elements) {
      if (PopupGift) {
        PopupGift.hide();
      }
    }
  });
  var popupAddedTemplate = document.querySelector('#PopupAddedTemplate');
  var popupAddedContainer = document.querySelector('#PopupAddedContainer');
  var popupAddedRelated = document.querySelector('[data-related-json]');

  // Cart gift popups
  var PopupGift = new _limelight2.default('#PopupGift', {
    bodyClass: 'active-popup',
    showCallback: function showCallback(element, elements) {
      var collection = (0, _jquery2.default)(element.target).find('[data-gift-collection]');
      var limit = (0, _jquery2.default)(collection).data('collection-products');
      var limit_medium = (0, _jquery2.default)(collection).data('collection-products-medium');
      var limit_small = (0, _jquery2.default)(collection).data('collection-products-small');

      var settings = (0, _slick2.default)({
        slidesToShow: limit,
        slidesToScroll: limit,
        appendArrows: (0, _jquery2.default)(element.target).find('.slick-arrows'),
        arrows: true,
        responsive: [{
          breakpoint: Breakpoints['large'],
          settings: {
            slidesToShow: limit_medium,
            slidesToScroll: limit_medium
          }
        }, {
          breakpoint: Breakpoints['small'],
          settings: {
            slidesToShow: limit_small,
            slidesToScroll: limit_small
          }
        }]
      });

      collection.slick(settings);

      var trigger = new Event('lazy:reload');
      document.dispatchEvent(trigger);
    },
    hideCallback: function hideCallback(element, elements) {
      var collection = (0, _jquery2.default)(element.target).find('[data-gift-collection]');
      collection.slick('unslick');
    }
  });

  // Cart error selectors
  var PopupError = new _limelight2.default('#PopupError', {
    bodyClass: 'active-popup'
  });
  var popupErrorTemplate = document.querySelector('#PopupErrorTemplate');
  var popupErrorContainer = document.querySelector('#PopupErrorContainer');

  // Cart page selectors
  var cartPageTemplate = document.querySelector('#CartPageTemplate');
  var cartPageContainer = document.querySelector('#CartPageContainer');

  window.AjaxCart.switchVariants = function (line, id) {
    var _this = this;

    var item = this.cart.items[line - 1];
    var quantity = item.quantity;
    var properties = item.properties;

    this.removeItemByLine(line, {
      success: function success(response) {
        var data = {
          id: id,
          quantity: quantity,
          properties: properties
        };
        _this.addItem(data, {
          success: function success(item) {
            _this.getCart();
          }
        });
      }
    });
  }.bind(AjaxCart);

  window.AjaxCart.renderCart = function (response) {
    if (response.items.length && response.gwp_event === '1') {
      window.AjaxCart.addItem({
        id: response.gwp_product_id,
        quantity: 1,
        properties: {
          "_new-gwp": true
        }
      }, {
        success: function success() {
          window.AjaxCart.getCart({
            success: function success(cart) {
              AjaxCart.renderCart(JSON.parse(cart));
            },
            error: function error(err) {
              console.error(err);
            }
          });
        },
        error: function error(err) {
          console.error(err);
        }
      });
    }
    if (response.items.length && response.gwp_event === '0') {
      window.AjaxCart.removeItemById(response.gwp_product_id, {
        success: function success() {
          window.AjaxCart.getCart({
            success: function success(cart) {
              AjaxCart.renderCart(JSON.parse(cart));
            },
            error: function error(err) {
              console.error(err);
            }
          });
        },
        error: function error(err) {
          console.error(err);
        }
      });
    }
    if (response.delete_gift) {
      window.AjaxCart.removeItemById(response.delete_gift, {
        success: function success() {
          window.AjaxCart.getCart({
            success: function success(cart) {
              AjaxCart.renderCart(JSON.parse(cart));
            },
            error: function error(err) {
              console.error(err);
            }
          });
        },
        error: function error(err) {
          console.error(err);
        }
      });
    }

    // Render the cart bag popup
    if (popupCartContainer) {
      var miniCartTemplateHandlebars = _handlebarsMin2.default.compile(miniCartTemplate.innerHTML);
      popupCartContainer.innerHTML = miniCartTemplateHandlebars(response);
      hoverCartContainer.innerHTML = miniCartTemplateHandlebars(response);
      hoverCartStickyContainer.innerHTML = miniCartTemplateHandlebars(response);
    }

    // Set cart qty text
    if (response.items.length) {
      cartQty.forEach(function (el) {
        el.innerHTML = response.item_count;
      });
      cartActive.forEach(function (el) {
        el.classList.add('active');
      });
      // Set Cookie (Show gift note in checkout page)
      var giftCount = 0;
      var cartItems = response.items;
      cartItems.forEach(function (element) {
        var elementPro = element.properties;
        if (elementPro) {
          if (elementPro._gift) {
            giftCount++;
          }
        }
        if (giftCount < 1) {
          _jsCookie2.default.set('_show_gift_note', '0');
        } else {
          _jsCookie2.default.set('_show_gift_note', '1');
        }
      });
    } else {
      cartActive.forEach(function (el) {
        el.classList.remove('active');
      });
    }

    // Render the cart page
    if (cartPageContainer) {
      var cartTemplateHandlebars = _handlebarsMin2.default.compile(cartPageTemplate.innerHTML);
      cartPageContainer.innerHTML = cartTemplateHandlebars(response);

      // Update the shipping selector to the correct item
      var shippingOptions = cartPageContainer.querySelectorAll('[name="ShippingSelector"]');
      if (shippingOptions.length > 1) {
        shippingOptions.forEach(function (element, index) {
          if (index == 0) {
            element.checked = false;
          } else if (index == 1) {
            element.checked = true;
          }
        });
      }

      var selectsTrigger = new Event('selects:update');
      document.dispatchEvent(selectsTrigger);

      var variantsTrigger = new CustomEvent('cart:rendered');
      document.dispatchEvent(variantsTrigger);

      var easeTrigger = new Event('ease:update');
      document.dispatchEvent(easeTrigger);

      var lazyTrigger = new Event('lazy:reload');
      document.dispatchEvent(lazyTrigger);

      var accordionTrigger = new Event('accordions:update');
      document.dispatchEvent(accordionTrigger);

      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();
      }
    }

    var currencyTrigger = new Event('currency:convert');
    document.dispatchEvent(currencyTrigger);

    if (document.querySelectorAll('[data-target="#PopupGift"]').length) {
      PopupGift.show();
    }
  };

  window.AjaxCart.renderAdded = function (resp) {
    var response = resp;

    // Curate the related products
    if (popupAddedRelated) {
      var collection = JSON.parse(popupAddedRelated.innerHTML);
      var related = [];

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = collection[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var product = _step.value;

          var contained = false;

          if (product.id == response.item.product_id) {
            continue;
          }
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = response.cart.items[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var item = _step2.value;

              if (item.product_id == product.id) {
                contained = true;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (!contained && related.length < 4) {
            related.push(product);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      response.related = related;
    }

    // Render the added to cart popup
    if (popupAddedContainer) {
      var popupAddedTemplateHandlebars = _handlebarsMin2.default.compile(popupAddedTemplate.innerHTML);
      popupAddedContainer.innerHTML = popupAddedTemplateHandlebars(response);

      var lazyTrigger = new Event('lazy:reload');
      document.dispatchEvent(lazyTrigger);

      var currencyTrigger = new Event('currency:convert');
      document.dispatchEvent(currencyTrigger);
    }

    // Re render the other cart elements
    AjaxCart.renderCart(response.cart);
  };

  // Render for the first time
  AjaxCart.renderCart(AjaxCart.cart);

  // Ajax cart callbacks
  document.addEventListener('cart:sending', function (event) {
    var response = event.detail.response;

    if (response.type == 'addItem') {
      var addButton = document.querySelector(AjaxCart.selectors.addItem);
      if (addButton) {
        // addButton.disabled = true;
        addButton.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addingToCart;
      }
    } else if (response.type == 'quickAdd') {
      var quickAddButton = document.querySelectorAll('[data-quick-add="' + response.item + '"]');
      if (quickAddButton) {
        quickAddButton.forEach(function (elem, index) {
          elem.disabled = true;
          elem.classList.add('is-adding');
          if (elem.querySelector(AjaxCart.selectors.addItemText)) {
            elem.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addingToCart;
          }
        });
      }
    } else if (response.type == 'removeItemByLine') {
      var removeItem = document.querySelectorAll('[data-cart-item="' + response.item + '"]');
      if (removeItem) {
        removeItem.forEach(function (elem, index) {
          elem.classList.add('is-removing');
        });
      }
    }
  });

  document.addEventListener('cart:itemAdded', function (event) {
    var response = event.detail.response;
    var addButton = document.querySelector(AjaxCart.selectors.addItem);
    var quickAddButton = document.querySelectorAll(AjaxCart.selectors.quickAdd + '.is-adding');
    var removeItem = document.querySelectorAll('[data-cart-item].is-removing');

    if (addButton) {
      addButton.disabled = false;
      addButton.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addToCart;
    }

    if (quickAddButton) {
      quickAddButton.forEach(function (elem, index) {
        elem.disabled = false;
        elem.classList.remove('is-adding');
        if (elem.querySelector(AjaxCart.selectors.addItemText)) {
          elem.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addToCart;
        }
      });
    }

    if (removeItem) {
      removeItem.forEach(function (elem, index) {
        elem.classList.add('is-removing');
      });
    }

    AjaxCart.renderAdded(response);
    if (!PopupGift.visible) {
      PopupAdded.show();
    } else {
      PopupGift.hide();
    }
  });

  document.addEventListener('cart:error', function (event) {
    var response = event.detail.response;
    var addButton = document.querySelector(AjaxCart.selectors.addItem);
    var quickAddButton = document.querySelectorAll(AjaxCart.selectors.quickAdd + '.is-adding');
    var removeItem = document.querySelectorAll('[data-cart-item].is-removing');

    if (addButton) {
      addButton.disabled = false;
      addButton.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addToCart;
    }

    if (quickAddButton) {
      quickAddButton.forEach(function (elem, index) {
        elem.disabled = false;
        elem.classList.remove('is-adding');
        if (elem.querySelector(AjaxCart.selectors.addItemText)) {
          elem.querySelector(AjaxCart.selectors.addItemText).innerHTML = theme.strings.addingToCart;
        }
      });
    }

    if (removeItem) {
      removeItem.forEach(function (elem, index) {
        elem.classList.add('is-removing');
      });
    }

    if (popupErrorContainer) {
      var popupErrorTemplateHandlebars = _handlebarsMin2.default.compile(popupErrorTemplate.innerHTML);
      popupErrorContainer.innerHTML = popupErrorTemplateHandlebars(response);
      PopupError.show();
    }
  });

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail.response;
    AjaxCart.renderCart(cart);
  });

  document.addEventListener('cart:requestsCompleted', function (event) {});

  (0, _jquery2.default)('body').on('click', '[data-add-product]', function () {
    (0, _jquery2.default)(this).parent().find('[data-error="' + (0, _jquery2.default)(this).data('add-product') + '"]').removeClass('hide');
  });

  var ajaxCartUpdate = function ajaxCartUpdate(data) {
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: { updates: data },
      dataType: 'json',
      success: function success(palette) {
        console.log(palette);
        window.AjaxCart.getCart({
          success: function success(cart) {
            AjaxCart.renderCart(JSON.parse(cart));
          },
          error: function error(err) {
            console.error(err);
          }
        });
      }
    });
  };

  (0, _jquery2.default)(document).on('click', '[data-remove-palette]', function (e) {
    e.preventDefault();

    var cnt = 0,
        paletteIds = (0, _jquery2.default)(this).attr('data-remove-palette'),
        paletteShades = (0, _jquery2.default)(this).parents('[data-cart-container]').find('.cart-item[data-palette-ids="' + paletteIds + '"]');
    var product_data = {};

    paletteShades.each(function () {
      var key = (0, _jquery2.default)(this).attr('data-key');
      product_data[key] = cnt;
    });

    ajaxCartUpdate(product_data);
  });

  (0, _jquery2.default)(document).on('change', '[data-palette-quantity]', function () {
    if ((0, _jquery2.default)(this).is(':checked')) {
      var cnt = (0, _jquery2.default)(this).val(),
          shadeId = (0, _jquery2.default)(this).attr('data-palette-ids'),
          paletteShades = (0, _jquery2.default)(this).parents('[data-cart-container]').find('.cart-item[data-palette-ids="' + shadeId + '"]');
      var product_data = {};

      paletteShades.each(function () {
        var key = (0, _jquery2.default)(this).attr('data-key');
        product_data[key] = cnt;

        (0, _jquery2.default)(this).addClass('is-removing');
      });

      ajaxCartUpdate(product_data);
    }
  });
};

exports.default = cartRendering;